import React from 'react';
import { CssBaseline, InputBase, ListItemText, ListItemIcon, Divider, List, Drawer, ListItem, Menu, MenuItem, IconButton, Badge, AppBar, Toolbar, Typography, Grid, Container, Paper } from "@material-ui/core";
import { AssessmentTwoTone as AssessmentTwoToneIcon, MoveToInbox as InboxIcon, Mail as MailIcon, Notifications as NotificationsIcon, Search as SearchIcon, More as MoreIcon, AccountCircle, ChevronRight as ChevronRightIcon, ChevronLeft as ChevronLeftIcon } from "@material-ui/icons";
import { makeStyles, useTheme, fade, ThemeProvider } from '@material-ui/core/styles';

import { Header, Footer, AnimatedMount, BulletItem, AnimationType } from "./layout";
import ResponsiveOrderedList, { ResponsiveOrderedListItem } from './layout/ResponsiveOrderedList';
import { LightningIcon, BulbIcon, ApplianceIcon, CameraIcon, FormIcon, HomeIcon, PriceIcon, EcoFloorIcon, EcoSunIcon, EcoFlexIcon, EcoFilmIcon, AirFilterIcon, VertigoIcon, WrenchIcon, ManipulateIcon, LifespanIcon, PensIcon, FixIcon, SecurityIcon } from "./layout/icons";
//import LightningIcon from "./layout/icons/Lightning";
import { theme, colors, IBackground } from './theme';
import { CircleIcon } from './layout/CircleIcon';
import { Theme } from '@material-ui/core';


const App: React.FC = () => {
  const classes = useStyles({ colors: colors.header });

  return (

    <ThemeProvider theme={theme}>
      <Header changeColorOffset={80} changeColor="black" />

      <main className={classes.main}>
        <Container>
          <h1>Návrhy a realizace elektrorozvodů a rozvaděčů</h1>
          <p>Provádíme návrhy a realizace elektrorozvodů a rozvaděčů. Připrávíme návrh i cenovou kalkulaci. Montujeme výrobky renovovaných společností <a href="https://nizke-napeti.cz.abb.com/" target="_blank" rel="noopener noreferrer">ABB</a>, <a href="https://www.legrand.cz/" target="_blank" rel="noopener noreferrer">Legrand</a> a <a href="http://www.vypinac.cz/" target="_blank" rel="noopener noreferrer">Schneider</a>  </p>
          <ResponsiveOrderedList numbered={false}>
            <ResponsiveOrderedListItem><BulletItem icon={<LightningIcon fill={colors.bullet.color} height={30} />}>Realizace a opravy silnoproudé elektroinstalace</BulletItem></ResponsiveOrderedListItem>
            <ResponsiveOrderedListItem><BulletItem icon={<HomeIcon fill={colors.bullet.color} height={30} />}>Rekonstrukce domů, bytů, kanceláří a nebytových prostor </BulletItem></ResponsiveOrderedListItem>
            <ResponsiveOrderedListItem><BulletItem icon={<ApplianceIcon fill={colors.bullet.color} height={30} />}>Zapojení kuchyňských spotřebičů</BulletItem></ResponsiveOrderedListItem>
            <ResponsiveOrderedListItem><BulletItem icon={<BulbIcon fill={colors.bullet.color} height={30} />}>Montáž nového osvětlení, opravy původního osvětlení</BulletItem></ResponsiveOrderedListItem>
            <ResponsiveOrderedListItem><BulletItem icon={<FormIcon fill={colors.bullet.color} height={30} />}>Zajistíme revizi</BulletItem></ResponsiveOrderedListItem>
            <ResponsiveOrderedListItem><BulletItem icon={<CameraIcon fill={colors.bullet.color} height={30} />}>Provádíme montáž vstupních systémů </BulletItem></ResponsiveOrderedListItem>
            <ResponsiveOrderedListItem><BulletItem icon={<PriceIcon fill={colors.bullet.color} height={30} />}>Připravíme Vám návrh včetně cenové nabídky</BulletItem></ResponsiveOrderedListItem>
          </ResponsiveOrderedList>


          <h1>Elektrické vytápění</h1>
          <p>Elektrické topení je velice efektivtivní řešení jak pro novostavby, tak i při rekonstrukci.
          Nabízíme široké spektrum topných systémů od podlahových topení, přes přímotopy až po stropní panely. V případě zájmu Vám připravíme návrh topného systému včetně kalkulace.
          Provádíme instalaci topných systémů <a href="https://www.fenixgroup.cz/cs" target="_blank" rel="noopener noreferrer">Fenix</a>.
          </p>
          <ul style={{ padding: 0 }}>
            <AnimatedMount onEnterAnimation={AnimationType.slideInUp} >
              <BulletItem icon={<EcoFloorIcon height={30} fill={colors.bullet.color} />}>ECOFLOOR - Elektrické topné kabely a topné rohože. Elektrické podlahové topení je velice praktické, jednoduché na instalaci, mají široké použití a ve srovnání s klasickým topením nízkou pořizovací cenu.</BulletItem>
            </AnimatedMount>
            <AnimatedMount onEnterAnimation={AnimationType.slideInUp} >
              <BulletItem icon={<EcoFilmIcon height={30} fill={colors.bullet.color} />}>ECOFILM - Topné fólie pro podlahovové a stropní panely. Hlavní přednostností je velice tenká fólie (jen 0,4 mm), která je jedinačná svou schopností vyhřevu po celé své ploše.</BulletItem>
            </AnimatedMount>
            <AnimatedMount onEnterAnimation={AnimationType.slideInUp} >
              <BulletItem icon={<EcoSunIcon height={30} fill={colors.bullet.color} />}>ECOSUN - Nízkoteplotní a vysokoteplotní sálavé topné panely na principu infračerveného vytápění</BulletItem>
            </AnimatedMount>
            <AnimatedMount onEnterAnimation={AnimationType.slideInUp} >
              <BulletItem icon={<EcoFlexIcon height={30} fill={colors.bullet.color} />}>ECOFLEX - Přímotopné a sálavé konvektory</BulletItem>
            </AnimatedMount>
          </ul>
          <h1>Zabezpečovací systémy</h1>
          <p>Provádíme návrh a montáž zabezpečovacích systémů <a href="https://www.jablotron.com/cz/" target="_blank" rel="noopener noreferrer">Jablotron</a> a kamerových systémů <a href="https://www.hikvision.com/cz/" target="_blank" rel="noopener noreferrer">Hikvision</a>  </p>
          <AnimatedMount onEnterAnimation={AnimationType.fadeInLeft} >
              <BulletItem icon={<SecurityIcon height={30} fill={colors.bullet.color} />}>Návrh a realizace zabezpečovacích systémů <a href="https://www.jablotron.com/cz/" target="_blank" rel="noopener noreferrer">Jablotron</a>.</BulletItem>
            </AnimatedMount>
            <AnimatedMount onEnterAnimation={AnimationType.fadeInLeft} >
              <BulletItem icon={<CameraIcon height={30} fill={colors.bullet.color} />}>Návrh a realizace kamerových systémů <a href="https://www.hikvision.com/cz/" target="_blank" rel="noopener noreferrer">Hikvision</a></BulletItem>
            </AnimatedMount>

          <h1>Centrální vysavače</h1>
          <p>Provádíme návrh i montáž centrálních vysavačů pro byty i domy značky <a href="https://husky.cz" target="_blank" rel="noopener noreferrer">Husky</a> Centrální vysavače jsou čisté a produkují zdravé prostředí. Jsou vhodné pro alergiky. Mají výhodu v tom, že veškeré nečistoty spolu s prachem, pily a alergeny vyfukují mimo dům.</p>
          <ResponsiveOrderedList numbered={false}>
            <ResponsiveOrderedListItem>
              <BulletItem icon={<VertigoIcon height={30} fill={colors.bullet.color} />}>Nevíří prach, jsou vhodné pro alergiky</BulletItem>
            </ResponsiveOrderedListItem>
            <ResponsiveOrderedListItem>
              <BulletItem icon={<AirFilterIcon height={30} fill={colors.bullet.color} />}>Přefiltrovaný vzduch se vyfukuje mimo objekt</BulletItem>
            </ResponsiveOrderedListItem>
            <ResponsiveOrderedListItem>
              <BulletItem icon={<LifespanIcon height={30} fill={colors.bullet.color} />}>Dlouhá životnost</BulletItem>
            </ResponsiveOrderedListItem>
            <ResponsiveOrderedListItem>
              <BulletItem icon={<ManipulateIcon height={30} fill={colors.bullet.color} />}>Snadná obsluha</BulletItem>
            </ResponsiveOrderedListItem>
            <ResponsiveOrderedListItem>
              <BulletItem icon={<WrenchIcon height={30} fill={colors.bullet.color} />}>Provádímé návrh včetně montáže</BulletItem>
            </ResponsiveOrderedListItem>
          </ResponsiveOrderedList>

          <h1>Hromosvody</h1>
          <ResponsiveOrderedList numbered={false}>
            <ResponsiveOrderedListItem><BulletItem icon={<PensIcon fill={colors.bullet.color} height={30} />}>Navrhneme a realizuje nové hromosvody</BulletItem></ResponsiveOrderedListItem>
            <ResponsiveOrderedListItem><BulletItem icon={<FixIcon fill={colors.bullet.color} height={30} />}>Provádíme rekustrukce starých hromosvodů</BulletItem></ResponsiveOrderedListItem>
            <ResponsiveOrderedListItem><BulletItem icon={<FormIcon fill={colors.bullet.color} height={30} />}>Zajistíme revizi</BulletItem></ResponsiveOrderedListItem>
            <ResponsiveOrderedListItem><BulletItem icon={<PriceIcon fill={colors.bullet.color} height={30} />}>Připravíme Vám návrh včetně cenové nabídky</BulletItem></ResponsiveOrderedListItem>
          </ResponsiveOrderedList>
        </Container>
      </main>
      <Footer />
    </ThemeProvider >
  )
}


interface IStyleProps {
  colors: IBackground;
}

const useStyles = makeStyles<Theme, IStyleProps>(() => ({

  main: props => ({
    color: colors.body.color,
    backgroundColor: colors.body.bgColor,
    borderTop: "1px solid rgb(37,37,37)",
    boxShadow: "0 16px 24px 2px rgba(0, 0, 0, 0.14), 0 6px 30px 5px rgba(0, 0, 0, 0.12), 0 8px 10px -5px rgba(0, 0, 0, 0.2)",
    padding: theme.spacing(3),
    paddingBottom: "100px",
    fontFamily: "oswald",
    "& h1": {
      fontFamily: "oswald-light",
      textAlign: "center",
    },
    "& a": {
      color: colors.body.color,

    },


  }),


}));

export default App;


// WEBPACK FOOTER //
// ./src/App.tsx